import PlayerPage from "./player-page/player-page"
import DirectionPage from "./direction-page/direction-page"

export { Home } from "./home/home"
export { Login } from "./login/login"
export { PlayerPage }
export { Registration } from "./registration/registration"
export { Subscribe } from "./subscribe/subscribe"
export { UserProfile } from "./user-profile/user-profile"
export { DirectionPage }
export { ListContents } from "./contents/list-contents/list-contents"
